import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "grid gap-3" }
const _hoisted_2 = {
  key: 0,
  class: "grid gap-3"
}
const _hoisted_3 = {
  key: 0,
  class: "border-secondary grid gap-3 rounded-md border p-2.5"
}
const _hoisted_4 = { class: "relative" }

import { InputRow, DatePicker, Select, Combobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import ThousandSeparatorInput from '@/components/ThousandSeparatorInput.vue';
    import { computed } from 'vue';
    import type { Company, SelectOption, Employee } from '@/types';
    import { useI18n } from 'vue-i18n';
    import EmployeeEmploymentSalaryChangesTable from '@/components/employees/EmployeeEmploymentSalaryChangesTable.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeEmploymentForm',
  props: {
    form: {},
    company: {},
    employee: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t, tm } = useI18n();

    const employmentTypeOptions = [
        { value: 'CustomerSalariedEmployee', label: 'employee.employment.salaried' },
        { value: 'CustomerHourlyEmployee', label: 'employee.employment.hourly' },
        { value: 'CustomerCEOEmployee', label: 'employee.employment.ceo' },
        // {
        //     value: 'CustomerBHonorariumReceiverEmployee',
        //     label: 'employee.employment.b_honorarium_receiver',
        // },
    ];

    const weeklyWorkingDaysOptions = Array.from({ length: 7 }, (_, i) => ({
        value: i + 1,
        label: i + 1,
    }));

    const taxCardOptions = [
        { value: 'hovedkort', label: 'employee.employment.primary_tax_card' },
        { value: 'bikort', label: 'employee.employment.secondary_tax_card' },
        { value: 'frikort', label: 'employee.employment.tax_exemption_card' },
    ];

    const allocationOfVacationDaysOptions = computed<SelectOption[]>(() => {
        const map = tm('employee.vacation.months') as Record<number, string>;
        return Object.entries(map).map(([value, label]) => ({ value: Number(value), label }));
    });

    const isSalaried = computed(
        () =>
            props.form.employment.employment_type === 'CustomerSalariedEmployee' ||
            props.form.employment.employment_type === 'CustomerCEOEmployee',
    );

    const isHourly = computed(
        () => props.form.employment.employment_type === 'CustomerHourlyEmployee',
    );

    const employeeOptional = computed(() => props.company?.employees_optional ?? {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "employment_type",
      label: "employee.employment.employment_type"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Select), {
          modelValue: _ctx.form.employment.employment_type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.employment.employment_type) = $event)),
          options: employmentTypeOptions,
          translate: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["form"]),
    (isSalaried.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(InputRow), {
            form: _ctx.form,
            name: "weekly_working_days",
            label: "employee.employment.weekly_working_days",
            "error-key": "employment.weekly_working_days"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Select), {
                modelValue: _ctx.form.employment.weekly_working_days,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.employment.weekly_working_days) = $event)),
                options: _unref(weeklyWorkingDaysOptions)
              }, null, 8, ["modelValue", "options"])
            ]),
            _: 1
          }, 8, ["form"]),
          _createVNode(_unref(InputRow), {
            form: _ctx.form,
            name: "weekly_working_hours",
            label: "employee.employment.weekly_working_hours",
            "error-key": "employment.weekly_working_hours"
          }, {
            default: _withCtx(() => [
              _createVNode(ThousandSeparatorInput, {
                id: "weekly_working_hours",
                modelValue: _ctx.form.employment.weekly_working_hours,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.employment.weekly_working_hours) = $event)),
                placeholder: _unref(t)('employee.employment.weekly_working_hours'),
                "with-decimals": ""
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["form"]),
          _createVNode(_unref(InputRow), {
            form: _ctx.form,
            name: "salary",
            label: 
                    _ctx.employee ? 'employee.employment.current_salary' : 'employee.employment.salary'
                ,
            "error-key": "employment.salary"
          }, {
            default: _withCtx(() => [
              _createVNode(ThousandSeparatorInput, {
                modelValue: _ctx.form.employment.salary,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.employment.salary) = $event)),
                placeholder: 
                        _ctx.employee
                            ? _unref(t)('employee.employment.current_salary')
                            : _unref(t)('employee.employment.salary')
                    ,
                "with-decimals": "",
                disabled: _ctx.employee
              }, null, 8, ["modelValue", "placeholder", "disabled"])
            ]),
            _: 1
          }, 8, ["form", "label"]),
          (_ctx.employee)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(InputRow), {
                  form: _ctx.form,
                  name: "salary",
                  label: "employee.employment.new_salary",
                  "error-key": "employment.salary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ThousandSeparatorInput, {
                      modelValue: _ctx.form.employment.new_salary,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.employment.new_salary) = $event)),
                      placeholder: _unref(t)('employee.employment.new_salary'),
                      "with-decimals": ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["form"]),
                _createVNode(_unref(InputRow), {
                  form: _ctx.form,
                  name: "new_salary_starts_at",
                  label: "employee.employment.new_salary_starts_at",
                  "error-key": "employment.salary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DatePicker), {
                      modelValue: _ctx.form.employment.new_salary_starts_at,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.employment.new_salary_starts_at) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["form"]),
                _createVNode(EmployeeEmploymentSalaryChangesTable, {
                  employee: _ctx.employee,
                  form: _ctx.form
                }, null, 8, ["employee", "form"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (isHourly.value)
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 1,
          form: _ctx.form,
          name: "hourly_rate",
          label: "employee.employment.hourly_rate"
        }, {
          default: _withCtx(() => [
            _createVNode(ThousandSeparatorInput, {
              modelValue: _ctx.form.employment.hourly_rate,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.employment.hourly_rate) = $event)),
              placeholder: _unref(t)('employee.employment.hourly_rate'),
              "with-decimals": ""
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "employment_date",
      label: "employee.personal.employment_date",
      "error-key": "customer_employees.employment_date"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DatePicker), {
          modelValue: _ctx.form.customer_employees.employment_date,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.customer_employees.employment_date) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "tax_card",
      label: "employee.employment.tax_card",
      "error-key": "employment.tax_card"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Select), {
          modelValue: _ctx.form.employment.tax_card,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.employment.tax_card) = $event)),
          options: taxCardOptions,
          translate: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["form"]),
    (employeeOptional.value.flex_savings)
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 2,
          form: _ctx.form,
          name: "flex_savings",
          label: "employee.optional.flex_savings",
          "error-key": "optional.flex_savings"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Input), {
                id: "flex_savings",
                modelValue: _ctx.form.optional.flex_savings,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.optional.flex_savings) = $event)),
                placeholder: _unref(t)('employee.optional.flex_savings'),
                type: "number",
                step: "any"
              }, null, 8, ["modelValue", "placeholder"]),
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-muted-foreground pointer-events-none absolute top-0 right-2.5 text-xs leading-7.5" }, " % ", -1))
            ])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true),
    (employeeOptional.value.days_vacation)
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 3,
          form: _ctx.form,
          name: "days_vacation",
          label: "employee.optional.days_vacation",
          "error-key": "optional.days_vacation"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Input), {
              id: "days_vacation",
              modelValue: _ctx.form.optional.days_vacation,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.optional.days_vacation) = $event)),
              placeholder: _unref(t)('employee.optional.days_vacation'),
              type: "number",
              step: "any"
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true),
    (employeeOptional.value.days_vacation)
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 4,
          form: _ctx.form,
          name: "allocation_of_vacation_days",
          label: "employee.optional.allocation_of_vacation_days"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Combobox), {
              modelValue: _ctx.form.optional.allocation_of_vacation_days,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.optional.allocation_of_vacation_days) = $event)),
              options: allocationOfVacationDaysOptions.value,
              placeholder: _unref(t)('employee.optional.allocation_of_vacation_days'),
              "show-remove-button": false,
              side: "top"
            }, null, 8, ["modelValue", "options", "placeholder"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true)
  ]))
}
}

})